import { checkPermission } from "@shared/utils/functions";

export default {
  computed: {
    permissions() {
      return {
        ro_refresh_frequency: checkPermission('revetting.ro_refresh_frequency'),
        rw_refresh_frequency: checkPermission('revetting.rw_refresh_frequency'),
        start_refresh: checkPermission('revetting.start_refresh'),
        allow_refresh_configuration: checkPermission('revetting.allow_refresh_configuration'),
        view_refresh_timeline: checkPermission('revetting.view_refresh_timeline'),
        read_refresh_sla: checkPermission('revetting.read_refresh_sla'),
      };
    },
  },
};
